import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { LienPriorityType } from 'constants/loanApplication';
import { lienPriorityOptions } from 'constants/options';

import { selectLoanApplication } from 'store/loanApplications/selectors/loanApplication.selectors';

const getAvailableLienPriority = (arr = []) => {
  const filteredArray = arr.filter(value => value !== LienPriorityType.OTHER);

  return lienPriorityOptions.filter(({ value }) => !filteredArray.includes(value));
};

const getFlatLienPriorities = (arr = []) => arr.map(({ lienPriority }) => lienPriority);

const selectUsedLienPriorities = createSelector(
  selectLoanApplication,
  ({ lienPriorities }) => lienPriorities,
);

export const selectLiabilityLienPriorityOptions = memoizeOne(isSubjectProperty =>
  createSelector(selectUsedLienPriorities, ({ loanLienPriority, additionalLoanLienPriorities }) => {
    return isSubjectProperty
      ? getAvailableLienPriority([
          loanLienPriority,
          ...getFlatLienPriorities(additionalLoanLienPriorities),
        ])
      : lienPriorityOptions;
  }),
);

export const selectLoanLienPriorityOptions = createSelector(
  selectUsedLienPriorities,
  ({ liabilityLienPriorities }) =>
    getAvailableLienPriority(getFlatLienPriorities(liabilityLienPriorities)),
);

export const selectAdditionalMortgageLienPriorityOptions = createSelector(
  selectUsedLienPriorities,
  ({ loanLienPriority, liabilityLienPriorities }) =>
    getAvailableLienPriority([loanLienPriority, ...getFlatLienPriorities(liabilityLienPriorities)]),
);
